export default "__VITE_ASSET__C06phhIP__"